import { LaunchpadType, useLaunchpadConfig } from "./useLaunchpadConfig";

import {
  BREX_TASKLIST_HEADING,
  DEFAULT_TASKLIST_HEADING,
  BOOKKEEPERS_TASKLIST_HEADING,
} from "./constants";

export const useTaskListHeader = () => {
  const { type } = useLaunchpadConfig();

  let taskListHeading = DEFAULT_TASKLIST_HEADING;

  if (type === LaunchpadType.Brex) {
    taskListHeading = BREX_TASKLIST_HEADING;
  } else if (type === LaunchpadType.Bookkeepers) {
    taskListHeading = BOOKKEEPERS_TASKLIST_HEADING;
  }

  return { taskListHeading };
};
